import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to top of page on route change
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Only scroll if pathname actually changed
    if (prevPathname.current !== pathname) {
      // Use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        // Also try document scrolling as fallback
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
      prevPathname.current = pathname;
    }
  }, [pathname]);

  return null;
};
